export default "__VITE_ASSET__BJLQSiSN__"